import SimpleApi from 'SharedDir/backend/api/classes/simpleApi';
import { PersonDeer, PersonDeerCreate } from 'SharedDir/declarations/physical-person';
import { personDeerUrl } from 'SharedDir/backend/endpoints/person-deer';

export default class PersonDeerApiClass extends SimpleApi<PersonDeer, PersonDeerCreate> {
  constructor() {
    super(personDeerUrl);
  }
}
